module.exports = __webpack_public_path__ + "img/edge_hiver_raquettes.817c2d19.svg";